import { Routes } from "@angular/router";
import { AuthGuard } from "@core/guards/auth-guard.service";

const mantenimientoPlaceholderRoutes: Routes = [
  {
    path: "mantenimiento/parametros/marcas-modelos",
    redirectTo: "mantenimiento/parametros/marcas",
    pathMatch: "full",
  },
  {
    path: "mantenimiento/parametros/marcas",
    loadComponent: () =>
      import("./pages/marcas-modelos/marcas.component").then(
        (m) => m.MarcasComponent,
      ),
    canActivate: [AuthGuard],
    data: {
      title: "Marcas",
      description: "Sección preparada para administrar marcas.",
    },
  },
  {
    path: "mantenimiento/parametros/modelos",
    loadComponent: () =>
      import("./pages/marcas-modelos/modelos.component").then(
        (m) => m.ModelosComponent,
      ),
    canActivate: [AuthGuard],
    data: {
      title: "Modelos",
      description: "Sección preparada para administrar modelos.",
    },
  },
  {
    path: "mantenimiento/parametros/materiales",
    loadComponent: () =>
      import("./pages/materiales/materiales.component").then(
        (m) => m.MaterialesComponent,
      ),
    canActivate: [AuthGuard],
    data: {
      title: "Materiales",
      description: "Sección preparada para administrar materiales.",
    },
  },
  {
    path: "mantenimiento/parametros/items",
    loadComponent: () =>
      import("./pages/items/items.component").then(
        (m) => m.ItemsComponent,
      ),
    canActivate: [AuthGuard],
    data: {
      title: "Items",
      description: "Sección preparada para administrar items.",
    },
  },
  {
    path: "mantenimiento/parametros/almacenes",
    loadComponent: () =>
      import("./pages/almacenes/almacenes.component").then(
        (m) => m.AlmacenesComponent,
      ),
    canActivate: [AuthGuard],
    data: {
      title: "Almacenes",
      description: "Sección preparada para administrar almacenes.",
    },
  },
  {
    path: "mantenimiento/parametros/depositos",
    loadComponent: () =>
      import("./pages/depositos/depositos.component").then(
        (m) => m.DepositosComponent,
      ),
    canActivate: [AuthGuard],
    data: {
      title: "Depósitos",
      description: "Sección preparada para administrar depósitos.",
    },
  },
  {
    path: "mantenimiento/parametros/depositos-almacenes",
    loadComponent: () =>
      import("./pages/depositos-almacenes/depositos-almacenes.component").then(
        (m) => m.DepositosAlmacenesComponent,
      ),
    canActivate: [AuthGuard],
    data: {
      title: "Depósitos por Almacén",
      description: "Sección para administrar depósitos por almacén.",
    },
  },
  {
    path: "mantenimiento/parametros/empresas",
    loadComponent: () =>
      import("./pages/empresas/empresas.component").then(
        (m) => m.EmpresasComponent,
      ),
    canActivate: [AuthGuard],
    data: {
      title: "Empresas",
      description: "Sección para consultar datos generales e impositivos de empresas.",
    },
  },
  {
    path: "mantenimiento/parametros/mano-obra",
    loadComponent: () =>
      import("./pages/mano-obra/mano-obra.component").then(
        (m) => m.ManoObraComponent,
      ),
    canActivate: [AuthGuard],
    data: {
      title: "Mano de Obra",
      description: "Sección preparada para administrar mano de obra.",
    },
  },
  {
    path: "mantenimiento/parametros/maquinaria",
    loadComponent: () =>
      import("./pages/maquinaria/maquinaria.component").then(
        (m) => m.MaquinariaComponent,
      ),
    canActivate: [AuthGuard],
    data: {
      title: "Maquinaria",
      description: "Sección preparada para administrar maquinaria.",
    },
  },
  {
    path: "mantenimiento/parametros/servicio-terceros",
    loadComponent: () =>
      import("./pages/servicio-terceros/servicio-terceros.component").then(
        (m) => m.ServicioTercerosComponent,
      ),
    canActivate: [AuthGuard],
    data: {
      title: "Servicio de Terceros",
      description: "Sección preparada para administrar servicios de terceros.",
    },
  },
  {
    path: "mantenimiento/parametros/tareas",
    loadComponent: () =>
      import("./pages/tareas/tareas.component").then(
        (m) => m.TareasComponent,
      ),
    canActivate: [AuthGuard],
    data: {
      title: "Tareas",
      description: "Sección preparada para administrar tareas.",
    },
  },
  {
    path: "mantenimiento/parametros/clase-mantenimiento",
    loadComponent: () =>
      import("./pages/clase-mantenimiento/clase-mantenimiento.component").then(
        (m) => m.ClaseMantenimientoComponent,
      ),
    canActivate: [AuthGuard],
    data: {
      title: "Clase de Mantenimiento",
      description: "Sección preparada para administrar clases de mantenimiento.",
    },
  },
  {
    path: "mantenimiento/parametros/unidades-equipos",
    loadComponent: () =>
      import("./pages/unidades-equipos/unidades-equipos.component").then(
        (m) => m.UnidadesEquiposComponent,
      ),
    canActivate: [AuthGuard],
    data: {
      title: "Unidades de Equipos",
      description: "Sección preparada para administrar unidades de equipos.",
    },
  },
  {
    path: "mantenimiento/parametros/equipos",
    loadComponent: () =>
      import("./pages/equipos/equipos.component").then(
        (m) => m.EquiposComponent,
      ),
    canActivate: [AuthGuard],
    data: {
      title: "Equipos",
      description: "Sección preparada para administrar equipos.",
    },
  },
  {
    path: "mantenimiento/parametros/centros-resultado",
    loadComponent: () =>
      import("./pages/centros-resultado/centros-resultado.component").then(
        (m) => m.CentrosResultadoComponent,
      ),
    canActivate: [AuthGuard],
    data: {
      title: "Centros de Resultado",
      description: "Sección para administrar centros de resultado.",
    },
  },
  {
    path: "mantenimiento/parametros/taller",
    loadComponent: () =>
      import("./pages/taller/taller.component").then(
        (m) => m.TallerComponent,
      ),
    canActivate: [AuthGuard],
    data: {
      title: "Taller",
      description: "Sección para administrar talleres.",
    },
  },
  {
    path: "mantenimiento/operaciones/codigos-operacion",
    loadComponent: () =>
      import("./pages/operaciones/operaciones.component").then(
        (m) => m.OperacionesComponent,
      ),
    canActivate: [AuthGuard],
    data: {
      title: "Operaciones",
      description: "Sección para administrar códigos de operación.",
    },
  },
  {
    path: "mantenimiento/operaciones/codigos-transaccion",
    loadComponent: () =>
      import("./pages/transacciones/transacciones.component").then(
        (m) => m.TransaccionesComponent,
      ),
    canActivate: [AuthGuard],
    data: {
      title: "Transacciones",
      description: "Sección para administrar códigos de transacción.",
    },
  },
  {
    path: "mantenimiento/operaciones/movimiento-equipos",
    loadComponent: () =>
      import("./pages/movimiento-equipos/movimiento-equipos.component").then(
        (m) => m.MovimientoEquiposComponent,
      ),
    canActivate: [AuthGuard],
    data: {
      title: "Movimiento de Equipos",
      description: "Sección para registrar movimientos diarios de equipos.",
    },
  },
  {
    path: "mantenimiento/operaciones/mantenimiento-preventivo",
    loadComponent: () =>
      import("./pages/mantenimiento-preventivo/mantenimiento-preventivo.component").then(
        (m) => m.MantenimientoPreventivoComponent,
      ),
    canActivate: [AuthGuard],
    data: {
      title: "Mantenimiento Preventivo",
      description: "Sección para consultar y preparar mantenimientos preventivos.",
    },
  },
  {
    path: "mantenimiento/operaciones/orden-trabajo-preventivo",
    loadComponent: () =>
      import("./pages/orden-trabajo-preventivo/orden-trabajo-preventivo.component").then(
        (m) => m.OrdenTrabajoPreventivoComponent,
      ),
    canActivate: [AuthGuard],
    data: {
      title: "Orden de Trabajo Preventivo",
      description: "Sección para gestionar órdenes de trabajo preventivo.",
    },
  },
  {
    path: "mantenimiento/operaciones/orden-trabajo-correctivo",
    loadComponent: () =>
      import("./pages/orden-trabajo-correctivo/orden-trabajo-correctivo.component").then(
        (m) => m.OrdenTrabajoCorrectivoComponent,
      ),
    canActivate: [AuthGuard],
    data: {
      title: "Orden de Trabajo Correctivo",
      description: "Sección para gestionar órdenes de trabajo correctivo.",
    },
  },
  {
    path: "mantenimiento/consultas/historial-orden-trabajo",
    loadComponent: () =>
      import("./pages/historial-orden-trabajo/historial-orden-trabajo.component").then(
        (m) => m.HistorialOrdenTrabajoComponent,
      ),
    canActivate: [AuthGuard],
    data: {
      title: "Historial de Orden de Trabajo",
      description: "Sección preparada para consultar el historial de órdenes de trabajo.",
    },
  },
  {
    path: "mantenimiento/consultas/movimiento-stock",
    loadComponent: () =>
      import("./pages/movimiento-stock/movimiento-stock.component").then(
        (m) => m.MovimientoStockComponent,
      ),
    canActivate: [AuthGuard],
    data: {
      title: "Consulta de Movimientos de Stock",
      description: "Sección preparada para consultar movimientos de stock.",
    },
  },
];

export const mantenimientoRoutes: Routes = [
  {
    path: "mantenimiento",
    loadComponent: () =>
      import("./pages/mantenimiento-home/mantenimiento-home.component").then(
        (m) => m.MantenimientoHomeComponent,
      ),
    canActivate: [AuthGuard],
    data: {
      label: "Inicio",
      icon: "build",
      urlexterna: "MANT",
    },
  },
  ...mantenimientoPlaceholderRoutes,
];